// extracted by mini-css-extract-plugin
export default {"myOrdersTable":"WZYwFISL4rUMMLvGzWZy"};